import { cn } from '@/lib/utils';

/** Gradient "Pro" badge — marks Pro-tier surfaces. */
export function ProPill({ className, label = 'Pro' }) {
	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-primary to-action px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm',
				className
			)}
		>
			{label}
		</span>
	);
}

/** "Free with Pro" pill — a paid channel covered by a Pro included slot. */
export function ProIncludedPill({ className }) {
	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full bg-gradient-unify px-2.5 py-1 text-xs font-semibold text-white shadow-sm',
				className
			)}
		>
			Free with Pro
		</span>
	);
}

/** "Included" pill — a channel that's free on every plan. */
export function IncludedPill({ className }) {
	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full border border-white/60 bg-white/95 px-2.5 py-1 text-xs font-semibold text-foreground shadow-sm backdrop-blur',
				className
			)}
		>
			Included
		</span>
	);
}
